import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { palletApiSlice } from './palletApiSlice';
export interface LpnNumber {
  id?: number;
  lpnNo: string;
  endStatusPallet: string;
  rqlState: string;
}

export interface ShippingMode {
  id: number;
  mode: string;
  [key: string]: any;
}

export interface PalletType {
  id?: string | number;
  projectId: number;
  variant: string;
  name: string;
  mode: string | number;
  numberOfPallets: number;
  percentage: number;
  plusByUser?: number;
  stackTestLayoutWeek?: string;
  stackPattern?: string;
  createdAt?: string;
  updatedAt?: string;
  lpnNumbers?: LpnNumber[];
  shippingModes?: ShippingMode[];
}

interface PalletsState {
  palletTypes: PalletType[];
  activePallet: PalletType | null;
  activeWeek: string | null,
  palletLeanWeeks: any,
  palletData: any
}

const initialState: PalletsState = {
  palletTypes: [],
  activePallet: null,
  activeWeek: null,
  palletLeanWeeks: [],
  palletData: {}
};

const palletsSlice = createSlice({
  name: 'pallets',
  initialState,
  reducers: {
    setPalletTypes: (state, action: PayloadAction<PalletType[]>) => {
      state.palletTypes = action.payload.map((pallet) => ({ ...pallet, lpnNumbers: [] }));
    },
    resetPalletTypes: (state) => {
      state.palletTypes = []
    },
    addPalletType: (state, action: PayloadAction<PalletType>) => {
      state.palletTypes.push({ ...action.payload, lpnNumbers: [] });
    },
    updatePalletType: (state, action: PayloadAction<PalletType>) => {
      const index = state.palletTypes.findIndex(pallet => pallet.id === action.payload.id);
      if (index !== -1) {
        state.palletTypes[index] = action.payload;
      }
    },
    removePalletType: (state, action: PayloadAction<string | number>) => {
      state.palletTypes = state.palletTypes.filter(pallet => pallet.id !== action.payload);
      if (state.activePallet && state.activePallet.id === action.payload) {
        state.activePallet = null;
      }
    },
    setActivePallet: (state, action: PayloadAction<PalletType | null>) => {
      state.activePallet = action.payload;
    },
    setActiveWeek: (state, action: PayloadAction<any>) => {
      state.activeWeek = action.payload;
    },
    setPalletLeanWeeks: (state, action: PayloadAction<string[] | []>) => {
      state.palletLeanWeeks = action.payload;
    },
    updatePalletLpnNumbers: (state, action: PayloadAction<{ palletId: number, lpnNumbers: LpnNumber[] }>) => {
      const pallet = state.palletTypes.find(p => p.id === action.payload.palletId);
      if (pallet) {
        pallet.lpnNumbers = action.payload.lpnNumbers;
      }
    },
    setPalletData: (state, action: PayloadAction<any>) => {
      state.palletData = action.payload;
      if (action.payload.palletTypes) {
        state.palletTypes = action.payload.palletTypes;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(palletApiSlice.endpoints.getPallets.matchFulfilled, (state, action) => {
      console.log(action.payload)
      state.palletTypes = action.payload.pallets
    });
  }
});

export const {
  setPalletTypes,
  addPalletType,
  updatePalletType,
  removePalletType,
  setActivePallet,
  updatePalletLpnNumbers,
  setActiveWeek,
  setPalletLeanWeeks,
  resetPalletTypes,
  setPalletData
} = palletsSlice.actions;
export default palletsSlice.reducer;
